export default __webpack_public_path__ + "static/media/Helm of the Atlantean.2b6e0fc2.jpg";